/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'Flash USDT Website',
    tagline: 'Flash USDT Website — Secure, Fast, Reliable',
    description:
      'Flash USDT Website is the most reliable USDT flashing solution. Flash up to $10,000,000 USDT daily with our secure, tradable, swappable, and transferable flash USDT software.',
  },

  domain: 'https://flashusdtwebsite.shop',

  contact: {
    orderEmail: 'buyflashusdtsoftware@gmail.com',
    supportEmail: 'buyflashusdtsoftware@gmail.com',
    whatsapp: '447950911750',
    phoneDisplay: '+44 7950 911750',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1q6eh6s2ycyzgzvp6dgkx8lhgnaefnfm3pe9w79d',
      usdt: 'TKcSCgxQ6xhM65oEoogES51TqQs5zURQHd',
    },
  },
};

export default siteConfig;
